import React, { useEffect, useState } from "react";
import { getcomplaindata, addorupdatecomplaindata } from "../../../Services/UserService/clientService";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Loader from "../../../../Utils/Loader";

const Complaindata = () => {
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("id");

    const [complainData, setComplainData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getsettingdetail = async () => {
        try {
            setIsLoading(true)
            const response = await getcomplaindata(token);
            if (response.status) {
                setComplainData(response.data[0] || {});
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getsettingdetail();
    }, []);

    if (isLoading) {
        return (
            <div>
                <Loader />
            </div>
        );
    }

    // ✅ Validation Schema
    const validationSchema = Yup.object().shape({
        received_during_month: Yup.number()
            .required("Received During Month is required")
            .min(0, "Value cannot be less than 0"),
        carried_forward: Yup.number()
            .required("Carried Forward is required")
            .min(0, "Value cannot be less than 0"),
        resolved_during_month: Yup.number()
            .required("Resolved During Month is required")
            .min(0, "Value cannot be less than 0"),
        pending_end_month: Yup.number()
            .required("Pending End Month is required")
            .min(0, "Value cannot be less than 0"),
    });

    return (
        <div className="page-content">
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Complain</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-12 mx-auto">
                    <div className="card radius-15">
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                received_during_month: complainData.received_during_month || "",
                                carried_forward: complainData.carried_forward || "",
                                resolved_during_month: complainData.resolved_during_month || "",
                                pending_end_month: complainData.pending_end_month || "",
                            }}
                            validationSchema={validationSchema} // ✅ Added validation here
                            onSubmit={async (values, { setSubmitting }) => {
                                const req = {
                                    ...values,
                                    id: user_id,
                                };

                                try {
                                    const response = await addorupdatecomplaindata(req, token);
                                    if (response.status) {
                                        showCustomAlert("Success", response.message);
                                        getsettingdetail();
                                    } else {
                                        showCustomAlert("error", response.message);
                                    }
                                } catch (error) {
                                    showCustomAlert(
                                        "error",
                                        "An unexpected error occurred. Please try again later."
                                    );
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ dirty, isSubmitting }) => (
                                <Form className="card-body">
                                    <div className="row mb-2">
                                        <label className="col-sm-3 col-form-label">
                                            <b>Received During Month</b>
                                        </label>
                                        <div className="col-sm-9">
                                            <Field
                                                name="received_during_month"
                                                type="number"
                                                className="form-control"
                                            />
                                            <ErrorMessage
                                                name="received_during_month"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <label className="col-sm-3 col-form-label">
                                            <b>Carried Forward</b>
                                        </label>
                                        <div className="col-sm-9">
                                            <Field
                                                name="carried_forward"
                                                type="number"
                                                className="form-control"
                                            />
                                            <ErrorMessage
                                                name="carried_forward"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <label className="col-sm-3 col-form-label">
                                            <b>Resolved During Month</b>
                                        </label>
                                        <div className="col-sm-9">
                                            <Field
                                                name="resolved_during_month"
                                                type="number"
                                                className="form-control"
                                            />
                                            <ErrorMessage
                                                name="resolved_during_month"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <label className="col-sm-3 col-form-label">
                                            <b>Pending End Month</b>
                                        </label>
                                        <div className="col-sm-9">
                                            <Field
                                                name="pending_end_month"
                                                type="number"
                                                className="form-control"
                                            />
                                            <ErrorMessage
                                                name="pending_end_month"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <label className="col-sm-3 col-form-label" />
                                        <div className="col-sm-9">
                                            <div className="d-flex justify-content-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                    disabled={!dirty || isSubmitting}
                                                >
                                                    {isSubmitting ? "Updating..." : "Update"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <style jsx>{`
              .error {
                color: red;
                font-size: 14px;
              }
            `}</style>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Complaindata;
